var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4545 4.22499C10.4545 5.7029 9.21856 6.94411 7.63636 6.94411C6.05416 6.94411 4.81818 5.7029 4.81818 4.22499C4.81818 2.74707 6.05416 1.50586 7.63636 1.50586C9.21856 1.50586 10.4545 2.74707 10.4545 4.22499ZM1 13.5228C1 13.282 1.11586 12.9903 1.50333 12.642C1.89645 12.2886 2.49018 11.9545 3.22596 11.6674C4.69804 11.093 6.48363 10.8037 7.63636 10.8037C8.78909 10.8037 10.5747 11.093 12.0468 11.6674C12.7826 11.9545 13.3763 12.2886 13.7694 12.642C14.1569 12.9903 14.2727 13.282 14.2727 13.5228V14.3824H1V13.5228Z",
    stroke: "#656A6E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.5b5148c932bdd9113bae9aa1af42af17.svg";
export { ForwardRef as ReactComponent };